import React, { useContext } from 'react'
import styles from '../styles/settings.module.css'
import StateContext from '../context/state/StateContext'
import UserContext from '../context/user/UserContext';
import { Link, Outlet, useLocation } from 'react-router-dom';

const Setting = () => {

  const { setModal } = useContext(StateContext);
  const { user } = useContext(UserContext)
  const location = useLocation();

  return (
    <>
      <div className={styles.settings}>
        <div className="row">
          <div className="col-md-3 col-12 h-100 px-0" style={{ borderRight: "1px solid #ddd" }}>
            <h4>Settings</h4>
            <ul>
              <Link to="/dashboard/setting/profile"><li className={location.pathname == "/dashboard/setting/profile" ? styles.active : null}><i class="fa-solid fa-user-pen"></i> Profile</li></Link>
            </ul>
          </div>
          <div className="col-md-9 col-12">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  )
}

export default Setting
